var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-switch-button",on:{"click":function($event){return _vm.toggle()}}},[_c('svg',{staticClass:"switch-button"},[_c('use',_vm._b({},'use',{'href':'#icons_' + _vm.getIconName},false))])])}
var staticRenderFns = []

export { render, staticRenderFns }